import { Controller } from '@hotwired/stimulus';
import { waitForDownload } from '../js/download';

// Nouveau lot de badges QR : total de codes selon la catégorie et le nombre
// de planches (`capacities` : codes par planche, par rang de catégorie) ;
// bouton en attente tant que le ZIP se prépare, et tout nouvel envoi
// (Entrée) refusé jusque-là : il créerait un second lot.
export default class extends Controller {
    static targets = ['category', 'plates', 'total', 'token', 'submit'];
    static values = { capacities: Object };

    connect() {
        this.count();
    }

    count() {
        const capacity = this.capacitiesValue[this.categoryTarget.value];
        const plates = Number(this.platesTarget.value);
        this.totalTarget.textContent = capacity && plates > 0 ? `= ${plates * capacity} codes` : '';
    }

    submit(event) {
        if (this.pending) {
            event.preventDefault();
            return;
        }
        this.pending = true;
        this.tokenTarget.value = waitForDownload(this.submitTarget, 'Préparation du ZIP…', () => { this.pending = false; });
    }
}
